<template>
	<div>
		<v-data-table
			style="cursor: pointer"
			:headers="headers"
			:items="items"
			@click:row="showItem"
			:items-per-page="50"
			:footerProps="{ 'items-per-page-options': [20, 50, 100, -1] }"
		>
			<template v-slot:item.createAt="props">
				<!-- {{ $moment(props.item.createAt.toDate()).format('YYYY/MM/DD HH:mm:ss') }} -->
				{{ formatTimestamp(props.item.createAt) }}
			</template>
			<template v-slot:item.price="props"> {{ $utils.addComma(props.item.price) }}원 </template>
		</v-data-table>

		<DesignerMenuEditDialog
			:show="editDialog"
			:item="selectedItem"
			icon="mdi-format-list-bulleted"
			title="메뉴 상세정보"
			okButtonText="확인"
			:okButton="false"
			cancelButtonText="닫기"
			:deleteButton="false"
			deleteButtonText="삭제"
			@onCancel="
				selectedItem = $models.MenuModel.create();
				editDialog = false;
			"
		>
		</DesignerMenuEditDialog>
	</div>
</template>

<script>
	import { formatTimestamp } from '@/js/util';

	export default {
		name: 'DesignerMenuList',
		props: {
			items: {
				default: [],
			},
			headers: {
				default: [],
			},
		},
		data: () => ({
			selectedItem: {},
			formValid: false,
			editDialog: false,
		}),
		mounted: function() {},
		methods: {
			formatTimestamp,
			showItem(item) {
				this.selectedItem = this.$models.MenuModel.set(item);
				this.selectedItem.id = item.id;
				this.editDialog = true;
			},
		},
	};
</script>

<style scoped></style>
